import angular from 'angular';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalKiss', PrincipalKissData);

    /* @ngInject */
    function PrincipalKissData($translate, logger, UtilSvc, PRINCIPAL) {
        PrincipalKiss.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            prepareForServer: prepareForServer,
            isEditable: isEditable,
        };

        function PrincipalKiss(principalKissData) {
            if (!principalKissData) {
                this.buildEmpty();
            } else {
                this.build(principalKissData);
            }
        }

        return PrincipalKiss;

        /////////////////////

        function buildEmpty() {
            this.paramKiss = false;
            this.initParamKiss = this.paramKiss;
            this.ladTypeAuto = false;
            this.ladTypeExtern = false;
            this.ladTypeMyInvoice = false;
            this.invitationType = PRINCIPAL.invitationType[0];
            this.emailTemplateType = PRINCIPAL.emailTemplateType[0];
            this.sellerInscriptionMaxRemind = 3;
            this.sellerInscriptionRemindInterval = 10;
            this.mailReport = null;
            this.hasSeller = null;
            this.reportRegistrationFrequency = PRINCIPAL.reportFrequencies[1]; // WEEKLY
            this.reportUsageFrequency = PRINCIPAL.reportFrequencies[2]; // MONTHLY
            this.reportLadAutoFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.invitedSellerReferentialSendingFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.invitedSellerReferentialDirectory = '';
            this.discussionImpExpActive = false;
            this.transmissionModeMail = false;
            this.transmissionModeFtp = false;
            this.hasSellerWithValidBusinessRelationship = null;
            this.reportInvFlyErrorFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.reportRemindersFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.reportRelationshipFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.reportIntegrationFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER
            this.platformPathFacturX = null;
        }

        function build(principalKissData) {
            this.paramKiss = true;
            this.initParamKiss = this.paramKiss;
            this.selfBilling = principalKissData.selfBilling || null;
            this.ladTypeAuto = _initLadTypeAuto(principalKissData.ladTypes);
            this.ladTypeExtern = _initLadTypeExtern(principalKissData.ladTypes);
            this.ladTypeMyInvoice = _initLadTypeMyInvoice(principalKissData.ladTypes);
            this.invitationType = principalKissData.invitationType || PRINCIPAL.invitationType[0];
            this.emailTemplateType = principalKissData.emailTemplateType || PRINCIPAL.emailTemplateType[0];
            this.sellerInscriptionMaxRemind = principalKissData.sellerInscriptionMaxRemind || 3;
            this.sellerInscriptionRemindInterval = principalKissData.sellerInscriptionRemindInterval || 10;
            this.mailReport = UtilSvc.splitMail(principalKissData.mailReport);
            this.hasSeller = principalKissData.hasSeller || null;
            this.reportRegistrationFrequency =
                principalKissData.reportRegistrationFrequency || PRINCIPAL.reportFrequencies[1];
            this.reportUsageFrequency = principalKissData.reportUsageFrequency || PRINCIPAL.reportFrequencies[2];
            this.reportLadAutoFrequency = principalKissData.reportLadAutoFrequency || PRINCIPAL.reportFrequencies[3];
            this.invitedSellerReferentialSendingFrequency =
                principalKissData.invitedSellerReferentialSendingFrequency || PRINCIPAL.reportFrequencies[3]; // NEVER
            this.invitedSellerReferentialDirectory = principalKissData.invitedSellerReferentialDirectory;
            this.discussionImpExpActive = !!principalKissData.discussionImpExpActive;
            this.transmissionModeMail = principalKissData.transmissionModeMail;
            this.transmissionModeFtp =
                (!principalKissData.transmissionModeFtp && !principalKissData.transmissionModeMail) ||
                principalKissData.transmissionModeFtp;
            this.hasSellerWithValidBusinessRelationship =
                principalKissData.hasSellerWithValidBusinessRelationship || null;
            this.reportInvFlyErrorFrequency = principalKissData.reportInvFlyErrorFrequency;
            this.reportRemindersFrequency =
                principalKissData.reportRemindersFrequency || PRINCIPAL.reportFrequencies[3];
            this.reportRelationshipFrequency =
                principalKissData.reportRelationshipFrequency || PRINCIPAL.reportFrequencies[3];
            this.reportIntegrationFrequency =
                principalKissData.reportIntegrationFrequency || PRINCIPAL.reportFrequencies[3];
            this.platformPathFacturX = principalKissData.platformPathFacturX || null;
        }

        function _initLadTypeAuto(ladTypes) {
            if (ladTypes && ladTypes.length > 0) {
                return ladTypes.indexOf(PRINCIPAL.ladTypes[0]) !== -1;
            }
            return false;
        }

        function _initLadTypeExtern(ladTypes) {
            if (ladTypes && ladTypes.length > 0) {
                return ladTypes.indexOf(PRINCIPAL.ladTypes[1]) !== -1;
            }
            return false;
        }

        function _initLadTypeMyInvoice(ladTypes) {
            if (ladTypes && ladTypes.length > 0) {
                return ladTypes.indexOf(PRINCIPAL.ladTypes[2]) !== -1;
            }
            return false;
        }

        function prepareForServer() {
            this.ladTypes = [];
            if (this.ladTypeAuto) {
                this.ladTypes.push(PRINCIPAL.ladTypes[0]);
            }
            if (this.ladTypeExtern) {
                this.ladTypes.push(PRINCIPAL.ladTypes[1]);
            }
            if (this.ladTypeMyInvoice) {
                this.ladTypes.push(PRINCIPAL.ladTypes[2]);
            }
            this.mailReport = UtilSvc.joinMail(this.mailReport);
        }

        function isEditable() {
            if (this.hasSeller === null) {
                return true;
            } else if (this.hasSeller === false) {
                return true;
            } else if (this.hasSeller === true && this.initParamKiss === false) {
                return true;
            }
            return false;
        }
    }
})();
